// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#CVuploadInput {
    display: none;
}

button:disabled {
    cursor: not-allowed;
    pointer-events: all !important;
}

::ng-deep .cdk-overlay-container {
    z-index: 1200 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/file-upload/file-upload.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":["#CVuploadInput {\r\n    display: none;\r\n}\r\n\r\nbutton:disabled {\r\n    cursor: not-allowed;\r\n    pointer-events: all !important;\r\n}\r\n\r\n::ng-deep .cdk-overlay-container {\r\n    z-index: 1200 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
